import React, { FC } from 'react';
import Expander from 'modules/shared/components/expander';

import './home-description.scss';

const HOME_DESCRIPTION = 'Cenojad.pl – smakosz najlepszych okazji zakupowych Cenojad.pl to platforma, która '
    + 'gromadzi i prezentuje najlepsze okazje zakupowe z wielu sklepów internetowych. Dzięki przejrzystej strukturze i '
    + 'intuicyjnemu wyszukiwaniu użytkownicy mogą łatwo znaleźć interesujące ich produkty. Dlaczego warto korzystać z '
    + 'Cenojad.pl? Serwis łączy oferty z wielu kategorii, od elektroniki i mody po kosmetyki i artykuły do domu. '
    + 'Dzięki filtrom i inteligentnemu wyszukiwaniu szybko znajdziesz produkty dopasowane do swoich potrzeb, bez '
    + 'konieczności przeglądania wielu stron. Najlepsze oferty w jednym miejscu Cenojad.pl agreguje propozycje z '
    + 'różnych sklepów, umożliwiając użytkownikom łatwe porównywanie ofert. Każdego dnia pojawiają się nowe okazje, '
    + 'dzięki czemu zawsze masz dostęp do aktualnych propozycji zakupowych. Intuicyjna obsługa i wygodne wyszukiwanie '
    + 'Serwis oferuje nowoczesne rozwiązania technologiczne, które ułatwiają znalezienie produktów. Proste menu i '
    + 'zaawansowane filtry pozwalają na szybkie i precyzyjne dopasowanie wyników do Twoich preferencji. Zakupy '
    + 'dostosowane do Twoich potrzeb Bez względu na to, czego szukasz – elektroniki, ubrań czy akcesoriów do domu – '
    + 'Cenojad.pl pomoże Ci znaleźć najlepsze propozycje. Śledź nowości i korzystaj z ofert dostępnych w jednym '
    + 'miejscu. Cenojad.pl – Twój przewodnik po okazjach Serwis pozwala oszczędzać czas i szybko docierać do '
    + 'najciekawszych ofert. Dzięki regularnym aktualizacjom i intuicyjnemu wyszukiwaniu masz dostęp do najlepszych '
    + 'okazji zakupowych. Sprawdź Cenojad.pl i odkryj produkty, które warto upolować!';

interface HomeDescriptionProps {
    isMobile?: boolean;
}

const HomeDescription: FC<HomeDescriptionProps> = ({ isMobile = false }) => {
    return (
        <div className="home-description">
            <Expander
                isReadMore={!isMobile}
                content={HOME_DESCRIPTION}
                shadowColorGradient="gray"
            />
        </div>
    );
};

export default HomeDescription;
